<template>

    <div class="label-node-report-text-container" :data-exec-mode="execMode" :style="{ '--max-width': maxWidth + 'px' }">

        <!-- Modo visualização -->
        <template v-if="!isEditingReportText || execMode == gConsts.rt.execModes.VIEW">
            <span :data-can-edit="!isEditingReportText && execMode == gConsts.rt.execModes.WORK ? 'true' : 'false'" class="label-node-report-text" @click="activateReportTextEditing">
                <report-line-text :text="reportText" class="label-node-report-text-line"></report-line-text>
                <!-- <span v-show="annotations.length > 0" class="label-node-report-text-locations">{{ annotationsString }}</span> -->
            </span>
        </template>

        <!-- Modo de edição (WORK) -->
        <template v-if="execMode == gConsts.rt.execModes.WORK && isEditingReportText">
            <span class="label-node-report-text">
                <span 
                    ref="inputSizer"
                    class="label-node-report-text-input-sizer"
                ></span>
                <label-line-input :annotations="reportNode?.annotation.list || []" :value="inputText" 
                    @input="onUpdateInputText" @blur="onBlurInputText" :autoFocus="true" :labelReportNode="reportNode" :style="{ 
                    // width: inputWidth + 'px',
                    minWidth: minWidth + 'px'
                }" :disabled="!canEdit" />
                <!-- <input 
                    ref="textInput"
                    v-model="inputText"
                    class="label-node-report-text-input"
                    type="text"
                    :style="{ 
                        width: inputWidth + 'px',
                        minWidth: minWidth + 'px'
                    }"
                    :disabled="!canEdit"
                    @blur="onUpdateInputText"
                    @input="updateInputWidth"
                /> -->
                <!-- <span v-show="locations.length > 0" class="label-node-report-text-locations">{{ locationsString }}</span> -->
            </span>
        </template>
    </div>
</template>

<script>
import { gConsts } from '@/globals/gConsts';
import labelLineInput from '@/features/report/components/input/label/labelReportLineInput.vue';
import reportLineText from '@/features/report/components/text/reportLineText.vue';

import { reportUtils } from '@/features/report/lib/reportUtils';

import ReportNode from '@/features/report/models/ReportNode';
import LabelAnnotation from '@/features/report/models/LabelAnnotation';

export default {
    name: 'labelNodeReportTextCMP',
    components: {
        labelLineInput,
        reportLineText
    },
    props: {
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        },
        reportNode: {
            type: ReportNode,
            required: true
        },
        reportText: {
            type: String,
            default: ''
        },
        annotations: {
            type: [LabelAnnotation, Array],
            default: () => []
        },
        canEdit: {
            type: Boolean,
            default: true
        },
        minWidth: {
            type: Number,
            default: 50
        },
        maxWidth: {
            type: Number,
            default: 300
        }
    },

    data() {
        return {
            gConsts: gConsts,
            inputText: this.reportText,
            inputWidth: this.minWidth,
            isEditingReportText: false,
            measureCanvas: null, // Canvas for text measurement
        }   
    },

    watch: {
        reportText: {
            handler(newVal) {
                // console.log('watch: reportText', newVal);
                this.inputText = newVal;
            },
            immediate: true
        },
        'inputText': {
            handler(newVal)  {
                this.$nextTick(() => {
                    this.updateInputWidth();
                });
            },
            immediate: true
        },
        annotations: {
            handler(newVal) {
                // console.log('watch: locations', newVal);
            },
            immediate: true
        }
    },

    computed: {
        annotationsString() {
            return reportUtils.getAnnotationsText(this.reportNode?.annotation.list || []);
        }

    },


    methods: {
        onUpdateInputText(value) {
            this.inputText = value;
            // console.log('onUpdateInputText', value);
            this.$emit('onUpdateInputText', this.inputText);
            this.$nextTick(() => {
                this.updateInputWidth();
            });
        },

        activateReportTextEditing() {
            if (this.execMode != gConsts.rt.execModes.WORK) 
                return;
            this.isEditingReportText = true;
        },

        onBlurInputText() {
            this.isEditingReportText = false;
        },

        /**
         * Measures text width using canvas, independent of DOM visibility
         * @param {string} text - The text to measure
         * @param {string} fontSize - Font size (e.g., '14px')
         * @param {string} fontFamily - Font family
         * @param {string} fontWeight - Font weight
         * @param {string} letterSpacing - Letter spacing (e.g., '0px')
         * @returns {number} The width in pixels
         */
         measureTextWidth(text, fontSize = '14px', fontFamily = 'inherit', fontWeight = 'normal', letterSpacing = '0px') {
            // Initialize canvas if not already created
            if (!this.measureCanvas) {
                this.measureCanvas = document.createElement('canvas');
            }
            
            const context = this.measureCanvas.getContext('2d');
            
            // Build font string for canvas context
            // Convert 'inherit' to a default font family
            const resolvedFontFamily = fontFamily === 'inherit' 
                ? window.getComputedStyle(document.body).fontFamily 
                : fontFamily;
            
            // Set font properties (canvas doesn't support letter-spacing directly)
            context.font = `${fontWeight} ${fontSize} ${resolvedFontFamily}`;
            
            // Measure text width
            const metrics = context.measureText(text || '\u00A0'); // Use non-breaking space if empty
            
            // Add letter spacing if specified (letter-spacing adds space between characters)
            const letterSpacingValue = parseFloat(letterSpacing) || 0;
            const textLength = text ? text.length : 1;
            const additionalSpacing = letterSpacingValue * Math.max(0, textLength - 1);
            
            return metrics.width + additionalSpacing;
        },
        
        updateInputWidth() {
            const text = this.inputText || '';
            
            // Get font properties from CSS or use defaults
            let fontSize = '14px';
            let fontFamily = 'inherit';
            let fontWeight = 'normal';
            let letterSpacing = '0px';
            
            // Try to get styles from input element if available, otherwise use CSS defaults
            if (this.$refs.textInput) {
                try {
                    const inputStyles = window.getComputedStyle(this.$refs.textInput);
                    fontSize = inputStyles.fontSize || fontSize;
                    fontFamily = inputStyles.fontFamily || fontFamily;
                    fontWeight = inputStyles.fontWeight || fontWeight;
                    letterSpacing = inputStyles.letterSpacing || letterSpacing;
                } catch (e) {
                    // If element is not accessible, use defaults from CSS
                    console.warn('Could not get computed styles, using defaults');
                }
            }
            
            // Calculate width using canvas measurement
            const width = this.measureTextWidth(text, fontSize, fontFamily, fontWeight, letterSpacing);

            // Add a small buffer (5px) and ensure minimum width
            // console.log('updateInputWidth', width);
            this.inputWidth = Math.max(this.minWidth, width);
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.updateInputWidth();
        });
    },
}
</script>

<style scoped>
    
.label-node-report-text-container {
    line-height: var(--leading-normal);
}

/* Modo visualização */

.label-node-report-text-container[data-exec-mode="view"] .label-node-report-text {
    font-size: var(--text-sm);
    color: var(--color-secondary);
}

.label-node-report-text-container[data-exec-mode="view"] .label-node-report-text-locations {
    background-color: transparent;
}


/* Modo de edição (WORK) */

.label-node-report-text {
    display: inline-block;
    text-align: left;
    font-family: var(--font-family-primary);
    font-size: var(--text-sm);
    color: var(--color-secondary);
    position: relative;
    max-width: max(var(--max-width, 300px), 70vw);
}

.label-node-report-text[data-can-edit="true"]:hover {
    opacity: 0.8 !important;
    cursor: text;
    /* text-decoration: underline; */
}

.label-node-report-text-container[data-exec-mode="work"] .label-node-report-text {
    animation: fadeIn 0.3s ease-in-out;
}

.label-node-report-text-input-sizer {
    position: absolute;
    visibility: hidden;
    height: auto;
    width: auto;
    overflow: hidden;
    white-space: pre;
    font-size: var(--text-sm);
    font-family: inherit;
    padding: 0;
    margin: 0;
    top: 0;
    left: 0;
}

.label-node-report-text-input {
    display: inline-block;
    max-width: 400px;
    font-size: var(--text-sm);
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    outline: none;
    color: inherit;
    padding: 0;
    margin: 0;
    margin-right: 2px;
    font-family: inherit;
    transition: border-bottom-color 0.2s ease, width 0.1s ease;
}

.label-node-report-text-input:not(:disabled):hover {
    border-bottom-color: rgba(0, 0, 0, 0.2);
}

.label-node-report-text-input:not(:disabled):focus {
    border-bottom-color: rgba(0, 0, 0, 0.4);
    background: rgba(255, 255, 255, 0.1);
    padding: 0px 2px;
    border-radius: 3px;
}

.label-node-report-text-locations {
    font-size: var(--text-xs);
    color: var(--color-secondary);
    background-color: var(--background-dark-gray);
    border-radius: var(--radius-sm);
    padding: 1px var(--spacing-sm);
    text-align: left;
    line-height: 1.7;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}
</style>